import React from 'react';
import {messages} from "../common/Translations";
import {injectIntl} from "react-intl";
import {toastr} from "react-redux-toastr";
import TreeEditor from './TreeEditor';
import CreateCategoryForm from "../categories/CreateCategoryForm";
import {bindActionCreators} from "redux";
import * as spinnerActions from '../../actions/spinnerActions';
import * as modalActions from "../../actions/common/modalActions";
import {connect} from "react-redux";
import * as categoryTreeEditorActions from "../../actions/categoryTreeEditorActions";
import * as portalActions from "../../actions/portal-contact/portalActions";
import ReactSelectFormatter from "../../services/ReactSelectFormatter";
import PlaceholderTable from "../common/PlaceholderTable";
import PlaceholderError from "../common/PlaceholderError";
import WithResolvedPromises from "../common/WithResolvedPromises";
import {CATEGORY_ITEMS} from "../editors/TreeEditorRouteTypes";

class TreeEditorContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            portalId: 1,
            actions: this.getRequiredActions(),
            showTable: true,
        };
    }

    getRequiredActions() {
        return [
            this.props.actions.fetchCategories(this.props.match.params.type, 1),
            this.props.actions.loadPortals()
        ]
    }

    onParentForNewCategorySelected(id) {
        this.setState({parentId: id});
    }

    onNewNodeNameChange(name) {
        this.setState({name: name});
    }

    onNodeNameEdit(params) {
        this.props.actions.showSpinner();
        this.props.actions.updateCategory(this.props.match.params.type, params)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.categoriesWebmasterCatNameUpdated))
            });
    }

    onMovedNode(params) {
        this.props.actions.showSpinner();
        this.props.actions.updateCategory(this.props.match.params.type, params)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.categoriesWebmasterCatPositionUpdated))
            });
        }

    onCreate() {
        if(this.state.name !== '') {
            this.props.actions.showSpinner();
            let params = {
                name: this.state.name,
                parentId: this.state.parentId,
                portalId: this.state.portalId
            };
            this.props.actions.addCategory(this.props.match.params.type, params)
                .then(() => {
                    this.props.actions.hideSpinner();
                    toastr.success(this.props.intl.formatMessage(messages.categoriesWebmasterCategoryCreated))
                });
            this.setState({showCreateModal: false});
        }
    }

    onDelete(id) {
        this.props.actions.showSpinner();
        this.props.actions.deleteCategory(this.props.match.params.type, id)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.categoriesWebmasterCategoryDeleted))
            })
            .catch(error => {
                this.props.actions.hideSpinner();
                toastr.error(error.message);
            });
    }

    onPortalChange(portalId) {
        this.setState({showTable: false, portalId});
        this.props.actions.fetchCategories(this.props.match.params.type, portalId).then(() => {
            this.setState({showTable: true})
        });
    }

    matchesCurrentPath(item) {
        return item.href.split('#').pop() === window.location.href.split('#').pop();
    }

    getPageTitles() {
        return CATEGORY_ITEMS.find(this.matchesCurrentPath);
    }

    render() {
        let pageTitles = this.getPageTitles();

        return (
            <WithResolvedPromises preloaderComponent={PlaceholderTable} promises={this.state.actions}
                                  errorComponent={PlaceholderError}>
            {
                addActions => {
                    return (
                        this.state.showTable ? (<TreeEditor
                                title={pageTitles ? pageTitles.title : ''}
                                subTitle={pageTitles ? pageTitles.subTitle : ''}
                                portals={this.props.portals}
                                portalId={this.state.portalId}
                                fetchedData={this.props.fetchedData}
                                onCreatedNode={this.onCreate.bind(this)}
                                onMovedNode={this.onMovedNode.bind(this)}
                                onDeletedNode={this.onDelete.bind(this)}
                                onSubmit={this.onCreate.bind(this)}
                                onNodeNameEdit={this.onNodeNameEdit.bind(this)}
                                onPortalChange={this.onPortalChange.bind(this)}
                            >
                                <CreateCategoryForm
                                    onCategorySelected={this.onParentForNewCategorySelected.bind(this)}
                                    categories={this.props.fetchedData}
                                    onNameChange={this.onNewNodeNameChange.bind(this)}
                                    dataTypeName="category"
                                />
                            </TreeEditor>
                        )
                        : <PlaceholderTable/>
                    )
                }
            }
            </WithResolvedPromises>
        )
    }
}

function mapStateToProps(state) {

    return {
        user: state.user,
        fetchedData: state.treeEditorCategories,
        portals: ReactSelectFormatter.format(state.portals || []),
        portalId: state.portalId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...modalActions,
                ...spinnerActions,
                ...categoryTreeEditorActions,
                ...portalActions
            },
            dispatch
        )
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(TreeEditorContainer));


// WEBPACK FOOTER //
// ./web/src/components/editors/TreeEditorContainer.jsx